import * as React from 'react';
import { connect } from 'react-redux';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';

import Button from 'antd/lib/button/button';
import { message, Form, Input, Row, Col, Select, AutoComplete, DatePicker, Divider, Checkbox } from 'antd';
import { NameOf } from 'src/utils/NameOf';
import { FormComponentProps } from 'antd/lib/form';
import moment from 'moment';
import { Roles } from 'src/constants/Roles';
import KeyValueDTO from 'src/models/generic/KeyValueDTO';
import { Grades } from 'src/constants/Grades';
import ArrayUtil from 'src/utils/ArrayUtil';
import Languages from 'src/constants/Languages';
import FieldDecorator from 'src/components/common/form/FieldDecorator';
import { ReduxStoreModel } from 'src/redux/ReduxModel';
import { UserState } from 'src/redux/UserReducer';
import { SelectValue } from 'antd/lib/select';
import EmulationDTO from 'src/models/account/EmulationDTO';
import UpdateSchoolDTO from 'src/models/school/UpdateSchoolDTO';

interface AddEditSchoolFormProps extends FormComponentProps, LocalizeContextProps {
    schoolData: Partial<UpdateSchoolDTO>;

    isSubmitting: boolean;

    onSubmit: (values: UpdateSchoolDTO) => void;
    onCancel: () => void;
}

class AddEditSchoolForm extends React.Component<AddEditSchoolFormProps> {
    constructor(props: AddEditSchoolFormProps) {
        super(props);
        bindAllOfThis(this, AddEditSchoolForm.prototype);
    }

    private handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        const otherId = this.props.form.getFieldValue(NameOf<UpdateSchoolDTO>("otherId"));
        const classLinkSourcedId = this.props.form.getFieldValue(NameOf<UpdateSchoolDTO>("classLinkSourcedId"));
        const hasCleverInfo = otherId != null && otherId.trim() !== '';
        const hasClassLinkInfo = classLinkSourcedId != null && classLinkSourcedId.trim() !== '';

        if (hasCleverInfo && hasClassLinkInfo) {
            this.props.form.setFields({
                otherId: {
                value: this.props.schoolData.otherId,
                errors: [new Error(this.props.translate('admin.addEditSchool.messageTooManySSOProvers').toString())],
                },
                classLinkSourcedId: {
                value: this.props.schoolData.classLinkSourcedId,
                errors: [new Error(this.props.translate('admin.addEditSchool.messageTooManySSOProvers').toString())],
                },
            });
            return false;
        }
        this.props.form.validateFields((errors, values: UpdateSchoolDTO) => {
            let newValues = { ...this.props.schoolData, ...values } as UpdateSchoolDTO;
            if (!errors) {
                this.props.onSubmit && this.props.onSubmit(newValues);
            }
        });
    }

    private handleCancel() {
        this.props.onCancel && this.props.onCancel();
    }

    render() {
        let schoolData = this.props.schoolData != null ? this.props.schoolData : {} as UpdateSchoolDTO;
        let isCleverEnabled = this.props.form.getFieldValue(NameOf<UpdateSchoolDTO>("connectToClever"));
        let isClassLinkEnabled = this.props.form.getFieldValue(NameOf<UpdateSchoolDTO>("connectToClassLink"));
        // GetFieldValue is undefined on form initialization
        isCleverEnabled = isCleverEnabled != null ? isCleverEnabled : schoolData.connectToClever;
        isClassLinkEnabled = isClassLinkEnabled != null ? isClassLinkEnabled : schoolData.connectToClassLink;

        return (
            <Form className="admin-form" onSubmit={this.handleSubmit}>
                <FieldDecorator
                    form={this.props.form}
                    label={<Translate id="admin.addEditSchool.formItem1" />}
                    name={NameOf<UpdateSchoolDTO>("schoolName")}
                    initialValue={schoolData.schoolName}
                    rules={[
                        { required: true, message: <Translate id="admin.common.requiredRule" /> },
                    ]}
                >
                    <Input autoComplete="off" />
                </FieldDecorator>

                {/* Clever Form Inputs */}
                <FieldDecorator
                    form={this.props.form}
                    label={<Translate id="admin.addEditSchool.formItem3" />}
                    name={NameOf<UpdateSchoolDTO>("connectToClever")}
                    initialValue={schoolData.connectToClever}
                >
                    <Checkbox defaultChecked={schoolData.connectToClever} />
                </FieldDecorator>
                <FieldDecorator
                    form={this.props.form}
                    label={<Translate id="admin.addEditSchool.formItem2" />}
                    name={NameOf<UpdateSchoolDTO>("otherId")}
                    initialValue={schoolData.otherId}
                >
                    <Input autoComplete="off" disabled={!isCleverEnabled} required={isCleverEnabled} />
                </FieldDecorator>

                {/* ClassLink Form Inputs */}
                <FieldDecorator
                    form={this.props.form}
                    label={<Translate id="admin.addEditSchool.formItem5" />}
                    name={NameOf<UpdateSchoolDTO>("connectToClassLink")}
                    initialValue={schoolData.connectToClassLink}
                >
                    <Checkbox defaultChecked={schoolData.connectToClassLink} />
                </FieldDecorator>
                <FieldDecorator
                    form={this.props.form}
                    label={<Translate id="admin.addEditSchool.formItem4" />}
                    name={NameOf<UpdateSchoolDTO>("classLinkSourcedId")}
                    initialValue={schoolData.classLinkSourcedId}
                >
                    <Input autoComplete="off" disabled={!isClassLinkEnabled} required={isClassLinkEnabled} />
                </FieldDecorator>

                <Form.Item>
                    <Button type="primary" loading={this.props.isSubmitting} htmlType="submit">
                        <Translate id="admin.common.saveButton" />
                    </Button>
                    <Divider type="vertical" />
                    <Button onClick={this.handleCancel}>
                        <Translate id="common.back" />
                    </Button>
                </Form.Item>
            </Form>);
    }
}

export default withLocalize(Form.create()(AddEditSchoolForm));



// WEBPACK FOOTER //
// ./src/pages/admin/forms/AddEditSchoolForm.tsx